<template>
  <div
    class="chat-input-container"
    :style="{
      margin: isFullScreen() ? '0 0 16px 0' : '0 24px 16px 24px'
    }"
    @mousedown="allowTextSelection"
    @keydown="handleKeyupDiv"
  >
    <div
      v-if="!getIsAIEnd()"
      :class="{
        'stop-out': true,
        'stop-out-full': isFullScreen(),
        'stop-out-ImageGeneration':
          (getIsShowImageGeneration || getIsShowDouyinBZhangGuide) &&
          isFullScreen()
      }"
      @click="stopAIOut"
    >
      <img class="stop-icon" src="@/assets/image/aigc/stop-out.png" alt="" />
      <img
        class="stop-icon-hover"
        src="@/assets/image/aigc/stop-out-hover.png"
        alt=""
      />
      <span>停止输出</span>
    </div>
    <!-- 文件上传展示框 -->
    <div v-if="isShowFileUploadShow()" class="file-upload-show">
      <!-- 上传图片 -->
      <div v-if="fileList[0].type.includes('image')" class="img-box">
        <div v-if="fileLoding" class="mask">
          <img class="loading" src="@/assets/svg/file/loading.svg" />
        </div>
        <img class="upload-image no-drag" :src="fileImageUrl" />
        <el-tooltip
          effect="dark"
          content="不再围绕该文件提问"
          placement="top"
          popper-class="custom-zyq-prpper"
        >
          <!-- 删除文件图标 -->
          <img
            class="del-icon no-drag"
            src="@/assets/svg/file/guanbi-file.svg"
            @click="handleDeleteFileClick(0)"
          />
        </el-tooltip>
      </div>

      <template v-else>
        <!-- 上传文件卡片 -->
        <div v-for="(item, index) in fileList" :key="index" class="file-card">
          <el-tooltip
            effect="dark"
            content="不再围绕该文件提问"
            placement="top"
            popper-class="custom-zyq-prpper"
          >
            <!-- 删除文件图标 -->
            <img
              class="del-icon no-drag"
              src="@/assets/svg/file/guanbi-file.svg"
              @click="handleDeleteFileClick(index)"
            />
          </el-tooltip>
          <!-- 文件图标 -->
          <div class="file-icon no-drag">
            <div v-if="fileLoding" class="mask">
              <img class="loading" src="@/assets/svg/file/loading.svg" />
            </div>
            <img
              class="icon no-drag"
              :src="require(`@/assets/svg/file/${fileExtension}.svg`)"
            />
          </div>
          <!-- 文件信息 -->
          <div class="file-info">
            <!-- 文件标题 -->
            <div class="file-title">{{ item.name }}</div>
            <!-- 文件状态 上传中 -->
            <span v-if="fileLoding" class="file-status">上传中</span>
            <!-- 文件状态 上传失败 -->
            <span
              v-if="!fileLoding && fileLoadingStatus !== 'COMPLETED'"
              class="file-status"
              >上传失败</span
            >
            <!-- 文件详情 -->
            <span
              v-if="!fileLoding && fileLoadingStatus === 'COMPLETED'"
              class="file-detail"
              >{{ fileExtension }} {{ getfilesize(item.size) }}</span
            >
          </div>
        </div>
      </template>
    </div>
    <template v-if="isShowFileUploadShow()">
      <div style="width: 100%; display: flex; align-items: flex-end">
        <!-- 输入框（带【】内容高亮） -->
        <div
          class="highlight-wrapper"
          :class="{ 'use-highlight': useHighlight }"
          style="position: relative; flex: 1"
        >
          <div
            v-show="useHighlight"
            class="highlight-preview"
            v-html="highlightedChatValue"
          />
          <el-input
            v-if="isShowInput"
            id="chat-input"
            ref="chatInputRefs"
            v-model="chatValue"
            type="textarea"
            :placeholder="getPleaceholder"
            style="border: none; width: 100%"
            resize="none"
            :maxlength="chatValueLimit"
            :autosize="{ minRows: 1, maxRows: 10 }"
            :disabled="getDisabledInput()"
            @keydown.native="handleKeyup"
            @input="handleChangeInput"
          />
        </div>

        <div class="flex input-bottom flex-between">
          <div style="margin-left: 14px">
            <span
              v-if="getIsShowDouyinBZhangGuide"
              ref="msgUrlId"
              class="msg-url"
              @click="openGuide"
            >
              网站快捷入口：
              <span
                class="highlight-span pointer"
                @click="onhandleOpenThirdWeb(2)"
              >
                B站
              </span>
              <span
                class="highlight-span pointer"
                @click="onhandleOpenThirdWeb(1)"
              >
                抖音
              </span>
              <span
                class="highlight-span pointer"
                @click="onhandleOpenThirdWeb(3)"
              >
                小红书
              </span>
              <span
                class="highlight-span pointer"
                @click="onhandleOpenThirdWeb(4)"
              >
                快手
              </span>
              <span
                class="highlight-span pointer"
                @click="onhandleOpenThirdWeb(5)"
              >
                微博
              </span>
              <span
                class="highlight-span pointer"
                @click="onhandleOpenThirdWeb(6)"
              >
                今日头条
              </span>
            </span>
          </div>
          <div
            class="flex items-center"
            :style="{
              marginLeft: isFullScreen() ? '16px' : '8px',
              gap: isFullScreen() ? '12px' : '8px'
            }"
          >
            <span class="chat-input-length"
              >{{ chatValue.length }}/{{ chatValueLimit }}</span
            >
            <label
              v-if="orgInfo.organizationId !== 1000000"
              for="file-upload-input"
            >
              <el-tooltip
                effect="dark"
                :content="
                  isEarth
                    ? '联网搜索不支持上传文件'
                    : '支持上传Word、Excel、PDF、PPT、音频、TXT、图片文件'
                "
                placement="top"
                popper-class="custom-zyq-prpper"
              >
                <img
                  v-if="$store.state.ai.isScene.id === '1'"
                  src="@/assets/image/aigc/Paperclip.png"
                  alt=""
                  style="height: 24px; width: 24px"
                />
              </el-tooltip>
            </label>
            <input
              id="file-upload-input"
              type="file"
              style="display: none"
              :disabled="isEarth"
              @change="handleFileUpload"
            />
            <img
              v-if="(!chatValue && !fileList.length) || fileLoding"
              src="@/assets/image/aigc/icon_send_df.png"
              alt=""
              style="height: 26px; width: 26px"
            />
            <img
              v-if="(chatValue || fileList.length) && !fileLoding"
              src="@/assets/image/aigc/icon_send.png"
              alt=""
              style="height: 26px; width: 26px"
              @click="send"
            />
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <!-- 输入框（带【】内容高亮） -->
      <div
        class="highlight-wrapper"
        :class="{ 'use-highlight': useHighlight }"
        style="position: relative"
      >
        <div
          v-show="useHighlight"
          class="highlight-preview"
          v-html="highlightedChatValue"
        />
        <el-input
          v-if="isShowInput"
          id="chat-input"
          ref="chatInputRefs"
          v-model="chatValue"
          type="textarea"
          :placeholder="getPleaceholder"
          style="border: none"
          resize="none"
          :maxlength="chatValueLimit"
          :autosize="{ minRows: 2, maxRows: 10 }"
          :disabled="getDisabledInput()"
          @keydown.native="handleKeyup"
          @input="handleChangeInput"
        />
      </div>

      <div class="flex input-bottom flex-between">
        <div style="margin-left: 16px">
          <span
            v-if="getIsShowDouyinBZhangGuide"
            ref="msgUrlId"
            class="msg-url"
            @click="openGuide"
          >
            网站快捷入口：
            <span
              class="highlight-span pointer"
              @click="onhandleOpenThirdWeb(2)"
            >
              B站
            </span>
            <span
              class="highlight-span pointer"
              @click="onhandleOpenThirdWeb(1)"
            >
              抖音
            </span>
            <span
              class="highlight-span pointer"
              @click="onhandleOpenThirdWeb(3)"
            >
              小红书
            </span>
            <span
              class="highlight-span pointer"
              @click="onhandleOpenThirdWeb(4)"
            >
              快手
            </span>
            <span
              class="highlight-span pointer"
              @click="onhandleOpenThirdWeb(5)"
            >
              微博
            </span>
            <span
              class="highlight-span pointer"
              @click="onhandleOpenThirdWeb(6)"
            >
              今日头条
            </span>
          </span>
          <div v-if="!getisDeleted" class="model-operate">
            <span class="model-tip">切换模型</span>
            <div style="display: flex; align-items: center">
              <div
                class="select-wrapper"
                :style="{
                  marginRight: isFullScreen() ? '12px' : '8px'
                }"
              >
                <div
                  class="custom-display"
                  :class="{ selected: modelType }"
                  :style="{ cursor: !getIsAIEnd() ? 'not-allowed' : 'pointer' }"
                  @click.stop="handleCustomSelectClick"
                >
                  <span>{{ getCurrentModelName }}</span>
                  <i
                    class="el-icon-arrow-down select-arrow"
                    :class="{ 'is-reverse': isDropdownVisible }"
                  />
                </div>
                <el-select
                  ref="modelSelect"
                  v-model="modelType"
                  placeholder="请选择"
                  class="origin-select"
                  popper-class="model-select-popper"
                  @visible-change="handleVisibleChange"
                  @change="handleChangeModel"
                >
                  <el-option
                    v-for="item in getModelList()"
                    :key="item.llmType"
                    :label="item.displayName"
                    :value="item.llmType"
                  >
                    <span style="font-size: 12px">{{ item.displayName }}</span>
                  </el-option>
                </el-select>
              </div>
              <!-- TODO 联调使用这个item.searchEnable -->
              <template v-if="getIsDeepSeek">
                <el-tooltip
                  v-if="!isFullScreen()"
                  effect="dark"
                  content="联网搜索"
                  placement="top"
                >
                  <div
                    class="custom-display"
                    :class="{ selected: isEarth }"
                    style="margin-left: 12px"
                    @click="handleEarth"
                  >
                    <img
                      :src="
                        require(isEarth
                          ? '@/assets/image/aigc/Earth@2x.png'
                          : '@/assets/image/aigc/Earth_def.png')
                      "
                      alt=""
                      style="width: 14px; height: 14px"
                    />
                  </div>
                </el-tooltip>
                <div
                  v-else
                  class="custom-display"
                  :class="{ selected: isEarth }"
                  style="margin-left: 12px"
                  :style="{
                    padding: isFullScreen() ? '0 10px' : '0 8px'
                  }"
                  @click="handleEarth"
                >
                  <img
                    :src="
                      require(isEarth
                        ? '@/assets/image/aigc/Earth@2x.png'
                        : '@/assets/image/aigc/Earth_def.png')
                    "
                    alt=""
                    style="width: 14px; height: 14px"
                  />
                  <span style="position: relative; top: 1px">联网搜索</span>
                </div>
              </template>
            </div>
          </div>
        </div>
        <div
          class="flex items-center"
          :style="{
            marginLeft: isFullScreen() ? '16px' : '8px',
            gap: isFullScreen() ? '12px' : '8px'
          }"
        >
          <span class="chat-input-length"
            >{{ chatValue.length }}/{{ chatValueLimit }}</span
          >
          <label
            v-if="orgInfo.organizationId !== 1000000"
            for="file-upload-input"
          >
            <el-tooltip
              effect="dark"
              :content="
                isEarth
                  ? '联网搜索不支持上传文件'
                  : '支持上传Word、Excel、PDF、PPT、音频、TXT、图片文件'
              "
              placement="top"
              popper-class="custom-zyq-prpper"
            >
              <img
                v-if="$store.state.ai.isScene.id === '1'"
                class="no-drag"
                src="@/assets/image/aigc/Paperclip.png"
                alt=""
                style="height: 24px; width: 24px"
              />
            </el-tooltip>
          </label>
          <input
            id="file-upload-input"
            type="file"
            style="display: none"
            :disabled="isEarth"
            @change="handleFileUpload"
          />
          <img
            v-if="!chatValue"
            class="no-drag"
            src="@/assets/image/aigc/icon_send_df.png"
            alt=""
            style="height: 26px; width: 26px"
          />
          <img
            v-else
            class="no-drag pointer"
            src="@/assets/image/aigc/icon_send.png"
            alt=""
            style="height: 26px; width: 26px"
            @click="send"
          />
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import douyinGuide from '@/assets/image/aigc/douyin-guide.png'
import bilibiliGuide from '@/assets/image/aigc/bilibili-guide.png'
import eventBus from '@/utils/eventBus'
import { getExtract } from '@/api/aigc'
import { fileUpload, getUploadStatusInfoByTaskId } from '@/api/aigc/file'
import { formatLimits } from './config'
import OSS from 'ali-oss'
import { getOssConfig } from '@/api/file'
import { v4 as uuidv4 } from 'uuid'
import { getToken } from '@/utils/auth'
import SparkMD5 from 'spark-md5'
import { getItem } from '@/utils/localStorage'
import { mapState } from 'vuex'

export default {
  inject: [
    'isFullScreen',
    'setChatMessage',
    'getChatMessageList',
    'getTypeAIList',
    'getWS',
    'closeWS',
    'createWS',
    'getIsAIEnd',
    'setDisabledInput',
    'getDisabledInput',
    'removeChatMessageItem',
    'setIndexChatCustomKeyMessage',
    'setIsAIEnd',
    'setTmpMessage',
    'getModelType',
    'resetSessionAI',
    'setModelType',
    'getModelList',
    'getRealConversationId'
  ],
  props: {
    content: {
      type: String,
      default: ''
    },
    original: {
      type: String,
      default: ''
    },
    chatValueLimit: {
      type: Number,
      default: 5000
    },
    placeholder: {
      type: String,
      default: ''
    },
    conversationId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      fileList: [],
      fileExtension: '',
      fileImageUrl: null,
      fileLoding: false,
      fileLoadingStatus: 'NULL',
      taskId: '',
      chatValue: '',
      timer: null,
      visibleInputRecommendTopic: false,
      assemblecontent: '',
      douyinGuide,
      bilibiliGuide,
      isShowGuide: false,
      typeOptions: {
        1: {
          type: 1,
          label: '抖音',
          Rule: [
            /https:\/\/v.douyin.com\/[a-zA-Z0-9]+/,
            // ps: https://www.douyin.com/channel/300205?modal_id=7283326510973357368
            /https:\/\/www.douyin.com\/channel\/[a-zA-Z0-9]+/,
            // ps: https://www.douyin.com/video/7305034949109878042
            /https:\/\/www.douyin.com\/video\/[a-zA-Z0-9]+/,
            // https://www.douyin.com/discover?modal_id=7310527175906708771
            /https:\/\/www.douyin.com\/discover\?modal_id=[a-zA-Z0-9]+/
          ]
        },
        2: {
          type: 2,
          label: 'B站',
          Rule: [
            /https:\/\/www.bilibili.com\/video\/[a-zA-Z0-9]+/,
            /https:\/\/b23.tv\/[a-zA-Z0-9]+/
          ]
        },
        3: {
          type: 3,
          label: '小红书',
          Rule: [/http:\/\/xhslink.com\/[a-zA-Z0-9]+/]
        },
        4: {
          type: 4,
          label: '快手',
          Rule: [/https:\/\/www.kuaishou.com\/[a-zA-Z0-9]+/]
        },
        5: {
          type: 5,
          label: '微博',
          Rule: [/https:\/\/weibo.com\/tv\/show\//]
        },
        6: {
          type: 6,
          label: '今日头条',
          Rule: [/https:\/\/www.toutiao.com\/video\//]
        }
      },
      isEarth: false,
      // 阿里云oss
      client: null,
      // 取消上传
      cancel: false,
      // ossConfig
      ossConfig: {},
      orgInfo: null,
      // douyingRule: [
      //   /https:\/\/v.douyin.com\/[a-zA-Z0-9]+/,
      //   // ps: https://www.douyin.com/channel/300205?modal_id=7283326510973357368
      //   /https:\/\/www.douyin.com\/channel\/[a-zA-Z0-9]+/,
      //   // ps: https://www.douyin.com/video/7305034949109878042
      //   /https:\/\/www.douyin.com\/video\/[a-zA-Z0-9]+/,
      //   // https://www.douyin.com/discover?modal_id=7310527175906708771
      //   /https:\/\/www.douyin.com\/discover\?modal_id=[a-zA-Z0-9]+/
      // modelList: [
      //   {
      //     llmType: '1',
      //     displayName: 'DeepSeep R1'
      //   },
      //   {
      //     llmType: '2',
      //     displayName: 'Chat GPT'
      //   }
      // ],
      modelType: '', // 设置默认选中的值
      isDropdownVisible: false // 控制箭头旋转
    }
  },
  computed: {
    ...mapState({
      chatStoreValue: state => state.ai.chatValue
    }),
    // 高亮渲染：将【】内的内容着色
    highlightedChatValue() {
      const esc = str =>
        str
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/\"/g, '&quot;')
          .replace(/'/g, '&#39;')
          .replace(/\n/g, '<br/>')
      const text = this.chatValue || ''
      const escaped = esc(text)
      // 全角【】内文本包裹高亮span
      return escaped.replace(
        /【([^】]+)】/g,
        '【<span class="bracket-highlight">$1</span>】'
      )
    },
    // 是否需要启用高亮覆盖层：仅当包含全角【】时
    useHighlight() {
      return /【[^】]*】/.test(this.chatValue || '')
    },
    getisDeleted() {
      const item = this.getTypeAIList.find(item => item.checked)
      if (item?.llmTypes?.length) {
        return item?.llmTypes?.includes(12)
      }
      return !!this.getTypeAIList.find(
        // item => !item.isEnabled && !item.isPrivate && item.createdUserId !== this.userInfo.userId
        item => item.checked && item.isDeleted === 1
      )
    },
    getIsDeepSeek() {
      const currentModel = this.getModelList().find(
        item => item.llmType === this.modelType
      )
      this.isEarth = currentModel?.searchEnable ?? false ? this.isEarth : false
      return currentModel?.searchEnable ?? false
    },
    getDisabledValue() {
      return this.getDisabledInput()
    },
    getPleaceholder() {
      const list = this.getTypeAIList
      const isVideoExtract = list.find(
        item => item.checked && item.assistantType === 'VideoExtract'
      )
      const isImageGeneration = list.find(
        item => item.checked && item.assistantType === 'ImageGeneration'
      )

      return this.placeholder
        ? this.placeholder
        : isVideoExtract
        ? '请输入抖音、B站、小红书、快手、微博、今日头条视频链接（支持20分钟以内视频）'
        : isImageGeneration
        ? '欢迎使用AI图片生成,请输入图片描述'
        : this.$store?.state?.ai?.isScene?.id === '1'
        ? this.isEarth
          ? '请随时提问你想要了解的问题'
          : '请随时提问你想要了解的问题或直接上传文件'
        : '输入问题，Ctrl+Enter换行！'
    },
    getIsShowDouyinBZhangGuide() {
      return this.getTypeAIList.find(
        item => item.checked && item.assistantType === 'VideoExtract'
      )
    },
    getIsShowImageGeneration() {
      return this.getTypeAIList.find(
        item => item.checked && item.assistantType === 'ImageGeneration'
      )
    },
    // 热点助手是否显示
    getIsShowHotspot() {
      return !!this.getTypeAIList.find(
        item => item.checked && item.assistantType === 'Hotspot'
      )
    },
    isShowInput() {
      return true
    },
    getCurrentModelName() {
      // 添加日志来调试
      const model = this.getModelList().find(
        item => item.llmType === this.modelType
      )
      if (model?.displayName) {
        return model.displayName
      }
      return '请选择模型'
    },
    modelListData() {
      return this.getModelList()
    }
  },
  watch: {
    chatStoreValue: {
      handler(newValue) {
        if (newValue) {
          this.chatValue = newValue
        } else {
          this.chatValue = ''
        }
      },
      immediate: true
    },
    fileLoadingStatus: {
      handler(newValue, oldValue) {
        console.log(newValue, oldValue)
        if (
          newValue !== 'COMPLETED' &&
          newValue !== 'FAILED' &&
          newValue !== 'INVALID'
        ) {
          this.checkTaskStatus()
        } else {
          // 停止定时器
          clearInterval(this.timer)
          // 重置定时器为 null
          this.timer = null
          this.fileLoding = false
        }
      },
      immediate: true
    },
    content(val) {
      if (val) {
        this.chatValue = val
      }
    },
    getDisabledValue: {
      handler(val) {
        if (!val && this.$refs.chatInputRefs) {
          this.$nextTick(() => {
            this.$refs.chatInputRefs.focus()
          })
        }
      },
      immediate: true
    },
    modelListData: {
      handler(newList) {
        const selectedModel = newList.find(item => item.isSelect)
        console.log(99999, selectedModel)
        if (selectedModel) {
          this.modelType = selectedModel.llmType
        }
      },
      immediate: true,
      deep: true
    }
  },
  created() {
    document.addEventListener('click', this.closeShowGuide)
    eventBus.$on('aiSend', this.aiSend)
    eventBus.$on('templateSend', this.templateSend)
    this.setOssConfig()
    this.orgInfo = getItem('orgInfo')
    // 移除或注释掉这段代码，因为我们使用静态数据
    // this.modelList = this.getTypeAIList.filter(item => item.checked && item.assistantType === 'VideoExtract')
    // this.modelType = this.modelList.length > 0 ? this.modelList[0].llmType : ''
  },
  beforeDestroy() {
    document.removeEventListener('click', this.closeShowGuide)
    eventBus.$off('aiSend', this.aiSend)
    eventBus.$off('templateSend', this.templateSend)
  },
  methods: {
    stopAIOut() {
      if (
        this.getChatMessageList[this.getChatMessageList.length - 1].text
          .length < 1
      ) {
        this.removeChatMessageItem(this.getChatMessageList.length - 1, 1)
      } else {
        this.setIndexChatCustomKeyMessage(
          'tmpIsOk',
          this.getChatMessageList.length - 1,
          true
        )
        this.setIndexChatCustomKeyMessage(
          'isHistory',
          this.getChatMessageList.length - 1,
          true
        )
      }

      this.setIsAIEnd(true)
      this.setDisabledInput(false)
      this.closeWS()
    },
    handleChangeModel(val) {
      this.setModelType(
        val,
        this.getModelList().findIndex(item => item.llmType === val)
      )
      this.$emit(
        'changeModel',
        this.getModelList().find(item => item.llmType === val)
      )
    },
    handleEarth() {
      this.isEarth = !this.isEarth
      console.log(this.isEarth)
    },
    isShowFileUploadShow() {
      return (
        this.$store?.state?.ai?.isScene?.id === '1' && this.fileList?.length
      )
    },
    // 设置ossConfig
    async setOssConfig() {
      const { code, data } = await getOssConfig('/assistant')

      if (code === 1) {
        this.ossConfig = {
          region: data.region || 'oss-accelerate',
          accessKeyId: data.accessKeyId,
          accessKeySecret: data.accessKeySecret,
          secure: true,
          bucket: data.ossBucket,
          ossBucketUrl: data.ossBucketUrl,
          ossEndPoint: data.ossEndPoint,
          stsToken: data.securityToken,
          refreshSTSToken: this.setOssConfig, // 注册刷新令牌的函数
          refreshSTSTokenInterval: 300000
        }

        this.client = new OSS(this.ossConfig)
      } else {
        this.$message({
          message: data.msg,
          type: 'warning',
          customClass: 'amap-sug-result'
        })
      }
    },
    // 手动点击按钮上传文件
    async handleFileUpload(event) {
      if (this.isEarth) return
      this.$uweb?.setAction('Event_File_Upload_AI_Click')
      // 只能上传一个文件
      if (this.fileList.length > 0) {
        return this.$message({
          message: `最多只能上传1个文件`,
          type: 'warning',
          customClass: 'amap-sug-result'
        })
      }

      this.cancel = false
      // 获取选中的文件
      const files = event.target ? event.target.files : event

      // 上传文件数量是否超过1
      const isMoreThanOne = files.length > 1
      if (isMoreThanOne) {
        return this.$message({
          message: `最多上传1个文件，请重新选择`,
          type: 'warning',
          customClass: 'amap-sug-result'
        })
      }
      // 检查文件格式和大小是否符合要求
      const isValidFiles = this.checkFileFormatAndSize(files)
      if (!isValidFiles) return
      // 上传文件
      this.uploadFile(files[0])

      // 重置上传输入的值
      if (event.target) {
        event.target.value = ''
      }
    },
    // 检查上传文件格式和大小是否符合要求
    checkFileFormatAndSize(files) {
      for (let i = 0; i < files.length; i++) {
        const file = files[i]
        const extension = file.name.split('.').pop().toLowerCase()
        const fileSize = file.size

        // 检查文件格式
        let isValidFormat = false
        for (const limits of Object.values(formatLimits)) {
          if (limits.extensions.includes(extension)) {
            isValidFormat = true
            // 检查文件大小
            if (fileSize > limits.maxSize) {
              this.$message({
                message: `文件限制上传小于${limits.maxSize / 1024 / 1024}MB`,
                type: 'warning',
                customClass: 'amap-sug-result'
              })

              return false
            }
          }
        }
        if (!isValidFormat) {
          this.$message({
            message: `仅支持上传Word、Excel、PDF、音频、TXT、图片文件`,
            type: 'error',
            customClass: 'amap-sug-result'
          })

          return false
        }
      }
      return true
    },
    // 根据文件名获取文件类型
    getFileType(fileName) {
      const extension = fileName.split('.').pop().toLowerCase()

      return extension
    },
    getfilesize(size) {
      if (!size) return ''
      var num = 1024.0
      if (size < num) return size + 'B'
      if (size < Math.pow(num, 2)) return (size / num).toFixed(2) + 'KB'
      if (size < Math.pow(num, 3)) {
        return (size / Math.pow(num, 2)).toFixed(2) + 'MB'
      } // M
      if (size < Math.pow(num, 4)) {
        return (size / Math.pow(num, 3)).toFixed(2) + 'G'
      } // G
      return (size / Math.pow(num, 4)).toFixed(2) + 'T' // T
    },
    createImageUrl(file) {
      const reader = new FileReader()
      reader.onload = e => {
        this.fileImageUrl = e.target.result
      }
      reader.readAsDataURL(file)
    },
    async uploadFile(file) {
      this.fileLoding = true
      if (file.type.includes('image')) {
        this.createImageUrl(file)
      }
      this.fileList.push(file)
      const url = await this.uploadOSS(file)
      this.fileUrl = url
      const fileType = this.getFileType(file.name)

      if (!formatLimits.image.extensions.includes(fileType)) {
        this.computeMD5AndUpload(file, url, fileType, file.name)
      } else {
        this.fileLoadingStatus = 'COMPLETED'
        this.fileLoding = false
      }
    },
    // 上传阿里OSS
    async uploadOSS(file) {
      const client = new OSS(this.ossConfig)
      this.client = client

      // // 生成随机 UUID
      const fileUuid = uuidv4()
      // // 获取文件名称
      const fileName = file.name
      // 获取文件后缀
      const fileExtension = fileName.split('.').pop()
      // 文件类型`
      const fileType = this.getFileType(file.name)
      this.computedFileIcon(fileName)
      // 获取当前日期
      const date = new Date()
      const year = date.getFullYear()
      const month = date.getMonth() + 1
      const day = date.getDate()
      const options = {
        // 获取分片上传进度、断点和返回值。
        progress: (p, cpt, res) => {
          if (this.cancel) {
            client.cancel()
            this.cancel = false
          }
        },
        // 设置并发上传的分片数量。
        parallel: 4,
        // 设置分片大小。默认值为1 MB，最小值为100 KB。
        partSize: 1024 * 1024,
        // headers,
        // 自定义元数据，通过HeadObject接口可以获取Object的元数据。
        meta: { year: 2020, people: 'test' },
        mime: 'text/plain'
      }

      const {
        res: { requestUrls, status }
      } = await client.multipartUpload(
        `/assistant/${fileType}/${year}/${month}/${day}/${fileUuid}.${fileExtension}`,
        file,
        {
          ...options
        }
      )

      const url = this.removeUploadIdFromUrl(requestUrls[0])

      if (status === 200) {
        return url
      } else {
        this.$message.error({
          message: `文件${file.name}上传失败`,
          type: 'error',
          customClass: 'amap-sug-result'
        })
      }
    },
    // 检查任务状态并启动或停止轮询
    checkTaskStatus() {
      if (!this.timer) {
        // 启动轮询
        this.timer = setInterval(async () => {
          if (this.taskId) {
            const { code, data } = await getUploadStatusInfoByTaskId({
              taskId: this.taskId
            })
            if (code === 1) {
              this.fileLoadingStatus = data.taskStatus
            }
          }
        }, 500)
      }
    },
    // 移除url参数
    removeUploadIdFromUrl(urlString) {
      // 使用正则表达式删除 URL 中的 `?uploadId=...` 查询参数
      return urlString.replace(/(\?|&)uploadId=[^&]+/, '')
    },
    // 计算文件图标类型
    computedFileIcon(fileName) {
      const extension = fileName.split('.').pop().toLowerCase()
      this.fileExtension = extension
    },
    // 计算文件md5并上传
    computeMD5AndUpload(file, url, fileType, fileName) {
      const blobSlice =
        File.prototype.slice ||
        File.prototype.mozSlice ||
        File.prototype.webkitSlice
      const chunkSize = 2097152 // 2MB
      const chunks = Math.ceil(file.size / chunkSize)
      let currentChunk = 0
      const spark = new SparkMD5.ArrayBuffer()
      const fileReader = new FileReader()

      file.cmd5 = true // 文件状态为"计算md5..."

      fileReader.onload = async e => {
        spark.append(e.target.result)
        currentChunk++

        if (currentChunk < chunks) {
          loadNext()
        } else {
          const md5 = spark.end()

          try {
            const { code, data } = await fileUpload({
              fileMd5: md5,
              fileType,
              fileUrl: url,
              fileName
            })

            if (code === 1) {
              const taskId = data
              this.taskId = taskId
              await getUploadStatusInfoByTaskId({
                taskId: this.taskId
              })
            }
            spark.destroy()
            file.uniqueIdentifier = md5
            file.cmd5 = false
          } catch (error) {
            this.fileList.splice(0, 1)
            this.fileLoadingStatus = 'NULL'
            this.fileLoding = false
          }
        }
      }

      fileReader.onerror = () => {
        console.warn('oops, something went wrong.')
        file.cancel()
      }

      const loadNext = () => {
        const start = currentChunk * chunkSize
        const end =
          start + chunkSize >= file.size ? file.size : start + chunkSize

        fileReader.readAsArrayBuffer(blobSlice.call(file, start, end))
      }

      loadNext()
    },
    handleDeleteFileClick(index) {
      this.$uweb?.setAction('Event_File_Upload_Delete_AI_Click')
      this.fileList.splice(index, 1)
      this.fileImageUrl = null
      if (this.fileLoding) {
        this.uploadCancel()
      }
      this.fileLoadingStatus = 'NULL'
      this.taskId = ''
      // 停止定时器
      clearInterval(this.timer)
      // 重置定时器为 null
      this.timer = null
      this.fileLoding = false
    },
    handleChangeInput(val) {
      this.$emit('changeInput', val)
    },
    // 取消上传的方法
    uploadCancel() {
      this.cancel = true
    },
    handleKeyupDiv(e) {
      if (
        this.getIsShowHotspot &&
        this.isShowTemplateRender &&
        e.keyCode === 13 &&
        !e.ctrlKey
      ) {
        e.stopPropagation()
        this.send()
      }
    },
    // 判断来源类型
    getType(text) {
      for (const key in this.typeOptions) {
        const flag = this.typeOptions[key].Rule.some(item => item.test(text))
        if (flag) {
          return this.typeOptions[key].type
        }
      }
    },
    openGuide(e) {
      if (
        this.$refs.promptGuidePopup &&
        this.$refs.promptGuidePopup.contains(e.target)
      ) {
        return
      }
      e.stopPropagation()
      this.isShowGuide = !this.isShowGuide
    },
    closeShowGuide(e) {
      // 判断点击是否在msgUrlId元素内
      if (
        this.$refs.msgUrlId &&
        !this.$refs.msgUrlId.contains(e.target) &&
        document.getElementsByClassName('el-image-viewer__wrapper').length < 1
      ) {
        this.isShowGuide = false
      }
    },
    /**
     * index 聊天纪录的下标
     * montageTxt 待拼接的文案  目前在视频文案提取中生成选题稿中使用
     */
    resetAnswer(index, montageTxt = '') {
      let userText = this.getChatMessageList[index - 1].text
      console.log('resetAnswer1------------', montageTxt)
      if (montageTxt) userText += montageTxt
      console.log('resetAnswer2------------', index, montageTxt, userText)
      this.removeChatMessageItem(index, 1)
      this.setChatMessage({
        type: 'ai',
        text: '',
        hasNew: false,
        tmpIsOk: false,
        isCollect: false,
        isLike: false,
        isNoLike: false,
        thinkingTxt: '',
        status: 'PENDING'
      })
      this.sendWS(userText, false, '', {
        task_id: this.taskId,
        format: this.fileExtension,
        file_url: this.fileUrl,
        file_name: this.fileList.length ? this.fileList[0].name : '',
        file_size: this.fileList.length
          ? this.getfilesize(this.fileList[0].size)
          : ''
      })
    },
    templateSend(val) {
      this.$emit('userInput')
      this.sendWS(JSON.parse(val), true, '', {})
    },
    aiSend(record) {
      this.chatValue = record.value
      this.send()
    },
    sendOther(value) {
      this.sendWS(value, false, '', {})
    },
    // 对话式发送 自己也会发送消息
    dialogue(text, isTemplate, mode) {
      this.setChatMessage({
        type: 'user',
        text: text
      })
      this.setChatMessage({
        type: 'ai',
        text: '',
        hasNew: false,
        tmpIsOk: false,
        isCollect: false,
        isLike: false,
        isNoLike: false,
        status: 'PENDING'
      })
      this.sendWS(text, isTemplate, mode, {})
    },
    // 禁止冒泡防止复制文本的时候进行拖动
    allowTextSelection(event) {
      // 取消事件冒泡，确保文本选择事件能够正常触发
      event.stopPropagation()
    },
    handleKeyup(e) {
      if (e.keyCode === 13 && !e.ctrlKey) {
        e.preventDefault()
        if (this.chatValue) {
          this.send()
        }
      }
      if (e.keyCode === 13 && e.ctrlKey) {
        const input = this.$refs.chatInputRefs.$el.querySelector(
          '.el-textarea__inner'
        )
        const start = input.selectionStart
        const end = input.selectionEnd
        this.chatValue =
          this.chatValue.substring(0, start) +
          '\n' +
          this.chatValue.substring(end)
        this.$nextTick(() => {
          input.focus()
          input.setSelectionRange(start + 1, start + 1)
        })
      }
    },
    videoSend() {
      // const isDY = this.douyingRule.some(item => item.test(this.chatValue))
      // const isBL = this.bilibiliRule.some(item => item.test(this.chatValue))
      const isDY = this.getType(this.chatValue)
      const isBL = this.getType(this.chatValue)
      const isWb = this.getType(this.chatValue)
      const isTt = this.getType(this.chatValue)

      if (!isDY && !isBL && !isWb && !isTt) {
        this.setIsAIEnd(true)
        this.setDisabledInput(false)
        this.$message({
          message:
            '目前只支持提取短视频内容，无法提取电视剧、电影、文本等内容。',
          type: 'error',
          customClass: 'amap-sug-result'
        })
        return
      }

      // 全是换行符则清空
      if (this.chatValue.replace(/\n/g, '').length === 0) {
        this.chatValue = ''
        this.setIsAIEnd(true)
        this.setDisabledInput(false)
        return
      }
      this.$uweb && this.$uweb.setAction('Event_video_copy_extraction')
      this.setChatMessage({
        type: 'user',
        text: this.chatValue
      })
      this.setChatMessage({
        type: 'ai',
        text: '',
        videoLoadText: '正在分析链接',
        hasNew: false,
        tmpIsOk: false,
        isCollect: false,
        isLike: false,
        isNoLike: false,
        status: 'PENDING'
      })

      // const header = isDY
      //   ? 'https://aisyk.hokkj.cn/douyin?url='
      //   : 'https://aisyk.hokkj.cn/douyin?url='
      // let url = ''
      // if (isDY) {
      //   const v1 = this.chatValue.match(this.douyingRule[0])
      //     ? this.chatValue.match(this.douyingRule[0])[0]
      //     : undefined
      //   const v2 = this.chatValue.match(this.douyingRule[1])
      //     ? this.chatValue.match(this.douyingRule[1])['input']
      //     : undefined
      //   url = v1 || v2
      // }
      // if (isBL) {
      //   const v1 = this.chatValue.match(this.bilibiliRule[0])
      //     ? this.chatValue.match(this.bilibiliRule[0])[0]
      //     : undefined
      //   const v2 = this.chatValue.match(this.bilibiliRule[1])
      //     ? this.chatValue.match(this.bilibiliRule[1])[0]
      //     : undefined
      //   url = v1 || v2
      // }
      this.setDisabledInput(true)
      this.setIsAIEnd(false)
      this.$emit('userInput')
      // const api =
      //   'https://aisyk.hokkj.cn/douyin?url=' +
      //   encodeURIComponent()
      getExtract({ oriUrl: this.chatValue })
        .then(res => {
          const tmp = res.data
          const tmpVideo = document.createElement('video')
          tmpVideo.src = tmp
          tmpVideo.addEventListener('loadedmetadata', () => {
            const videoDuration = tmpVideo.duration
            tmpVideo.remove()
            // 换算为分钟
            const videoDurationMin = Math.floor(videoDuration / 60)
            if (videoDurationMin > 20) {
              this.setIndexChatCustomKeyMessage(
                'text',
                this.getChatMessageList.length - 1,
                '视频时长超过20分钟，无法处理!'
              )
              this.setIndexChatCustomKeyMessage(
                'status',
                this.getChatMessageList.length - 1,
                'DONE'
              )
              this.setIsAIEnd(true)
              this.setDisabledInput(false)
              return
            }
            if (tmp) {
              this.setIndexChatCustomKeyMessage(
                'videoLoadText',
                this.getChatMessageList.length - 1,
                '文案提取中'
              )
              this.sendWS(
                JSON.stringify({ user: this.chatValue, url: tmp, status: 1 }),
                false,
                '',
                {}
              )
              // if (isDY) {
              //   /**
              //    * user 用户输入
              //    * url 视频链接
              //    * status 1-提取 2-改稿
              //    */
              //   this.sendWS(
              //     JSON.stringify({ user: this.chatValue, url: tmp, status: 1 })
              //   )
              // }
              // if (isBL) {
              //   if (!tmp.bvid) {
              //     this.setIndexChatCustomKeyMessage(
              //       'text',
              //       this.getChatMessageList.length - 1,
              //       '视频无法获取！'
              //     )
              //     this.setIndexChatCustomKeyMessage(
              //       'status',
              //       this.getChatMessageList.length - 1,
              //       'DONE'
              //     )
              //     this.setIsAIEnd(true)
              //     this.setDisabledInput(false)
              //     return
              //   }
              //   getBilibiliPlayurl(tmp).then(rr => {
              //     /**
              //      * user 用户输入
              //      * url 视频链接
              //      * status 1-提取 2-改稿
              //      */
              //     this.sendWS(
              //       JSON.stringify({
              //         user: this.chatValue,
              //         url: rr.data,
              //         status: 1
              //       })
              //     )
              //   })
              // }
            } else {
              this.setIndexChatCustomKeyMessage(
                'text',
                this.getChatMessageList.length - 1,
                '链接内容无法提取'
              )
              this.setIndexChatCustomKeyMessage(
                'status',
                this.getChatMessageList.length - 1,
                'DONE'
              )
              this.setIsAIEnd(true)
              this.setDisabledInput(false)
            }
          })
        })
        .catch(() => {
          this.setIndexChatCustomKeyMessage(
            'text',
            this.getChatMessageList.length - 1,
            '链接内容无法提取'
          )
          this.setIndexChatCustomKeyMessage(
            'status',
            this.getChatMessageList.length - 1,
            'DONE'
          )
          this.setIsAIEnd(true)
          this.setDisabledInput(false)
        })
    },
    hotspostSend() {},
    // 发送消息  isAddUser  是否添加用户信息
    async send(isAddUser = true) {
      this.$uweb && this.$uweb.setAction('Event_click_send_btn')
      if (this.getDisabledInput()) return

      this.setDisabledInput(true)
      if (this.getIsShowDouyinBZhangGuide) {
        this.videoSend()
        return
      }
      if (this.getIsShowHotspot) {
        this.hotspostSend()
        return
      }
      if (this.fileList.length) {
        if (isAddUser) {
          this.setChatMessage({
            type: 'user',
            text:
              this.chatValue.replace(/\n/g, '').length === 0
                ? '整理文件的核心内容'
                : this.chatValue,
            messageType: 'file',
            fileImageUrl: this.fileImageUrl,
            fileExtension: this.fileExtension,
            fileName: this.fileList[0].name,
            format: this.fileExtension,
            fileSize: this.getfilesize(this.fileList[0].size)
          })
        } else {
          this.setChatMessage({
            type: 'user',
            text: this.chatValue
          })
        }
      } else {
        if (isAddUser) {
          // 全是换行符则清空
          if (this.chatValue.replace(/\n/g, '').length === 0) {
            this.chatValue = ''
            this.setIsAIEnd(true)
            this.setDisabledInput(false)
            return
          }

          this.setChatMessage({
            type: 'user',
            text: this.chatValue
          })
        }
      }

      this.$emit('userInput')
      this.setChatMessage({
        type: 'ai',
        text: '',
        thinkingTxt: '',
        hasNew: false,
        tmpIsOk: false,
        isCollect: false,
        isLike: false,
        isNoLike: false,
        status: 'PENDING'
      })
      if (this.fileList.length) {
        if (this.chatValue) {
          this.$uweb?.setAction(
            'Event_File_Upload_Conversation_Plain_Text_File_AI_Click'
          )
        } else {
          this.$uweb?.setAction('Event_File_Upload_Conversation_AI_Click')
        }
        this.sendWS(
          this.chatValue.replace(/\n/g, '').length === 0
            ? '整理文件的核心内容'
            : this.chatValue,
          false,
          '',
          {
            task_id: this.taskId,
            format: this.fileExtension,
            file_url: this.fileUrl,
            file_name: this.fileList[0].name,
            file_size: this.getfilesize(this.fileList[0].size)
          }
        )
      } else {
        this.$uweb?.setAction(
          'Event_File_Upload_Conversation_Plain_Text_AI_Click'
        )
        this.sendWS(
          this.chatValue.replace(/\n/g, '').length === 0
            ? '整理文件的核心内容'
            : this.chatValue,
          false,
          '',
          {}
        )
      }
    },
    clearChatValue() {
      this.chatValue = ''
    },
    async sendWS(val, isTemplate = false, mode = '', params) {
      this.setDisabledInput(true)
      this.setIsAIEnd(false)
      let ws = this.getWS()
      if (!ws || ws.readyState !== 1) {
        ws = await this.createWS()
        console.log('ws创建完成')
      }
      // 最后一条消息obj
      // const lastInfo =
      //   this.getChatMessageList[this.getChatMessageList.length - 1]
      ws.onmessage = event => {
        const info = {
          ...JSON.parse(event.data)
        }

        if (
          info.reply === 'check' &&
          info.conversation_id === 'check' &&
          info.status === 'CHECK' &&
          info.source === 'SYSTEM'
        ) {
          return
        }
        // TODO 跟后端联调搜索
        // console.log(info,'info------------------90909009-----------------------');
        if (info.status === 'PENDING' || info.status === 'DONE') {
          if (this.getIsShowImageGeneration) {
            if (info.status === 'DONE') {
              // 判断info.reply 是不是图片链接
              if (
                !info.reply.includes('http') &&
                !info.reply.includes('https')
              ) {
                this.setIndexChatCustomKeyMessage(
                  'imgError',
                  this.getChatMessageList.length - 1,
                  info.reply
                )
              }
              this.setIndexChatCustomKeyMessage(
                'text',
                this.getChatMessageList.length - 1,
                info.reply
              )
              this.setIndexChatCustomKeyMessage(
                'status',
                this.getChatMessageList.length - 1,
                'DONE'
              )
              this.setIndexChatCustomKeyMessage(
                'source',
                this.getChatMessageList.length - 1,
                info.source
              )
              this.setIndexChatCustomKeyMessage(
                'tmpIsOk',
                this.getChatMessageList.length - 1,
                true
              )
              this.setIndexChatCustomKeyMessage(
                'id',
                this.getChatMessageList.length - 1,
                info.conversation_id
              )
            }

            this.setIsAIEnd(true)
            this.setDisabledInput(false)
          } else {
            console.log(info, 'info222222222')
            info.applyType = info.type

            this.setTmpMessage(info)
          }
        }
        if (info.status === 'SENSITIVE') {
          this.removeChatMessageItem(this.getChatMessageList.length - 1, 1)

          this.setIndexChatCustomKeyMessage(
            'isSensitive',
            this.getChatMessageList.length - 1,
            true
          )
          this.setIndexChatCustomKeyMessage(
            'isSensitiveReply',
            this.getChatMessageList.length - 1,
            info.reply
          )
          this.setIsAIEnd(true)
          this.setDisabledInput(false)
          return
        }
      }
      ws.onclose = () => {}
      ws.onerror = () => {}
      const tmp = this.getTypeAIList.find(item => item.checked)
      // let notText = ''
      let tt = ''
      if (isTemplate) {
        await this.resetSessionAI()
        val.replaces.forEach(e => {
          // notText += e.replace_value || ''
          tt += e.replace_key + '：' + (e.replace_value || '') + '\n'
        })
        this.setChatMessage({
          type: 'user',
          text: tt,
          conversationId: this.conversationId
        })
        this.setChatMessage({
          type: 'ai',
          text: '',
          thinkingTxt: '',
          tmpIsOk: false,
          isCollect: false,
          isLike: false,
          hasNew: false,
          isNoLike: false,
          status: 'PENDING',
          conversationId: this.conversationId
        })
      }
      let us = isTemplate
        ? this.getIsShowDouyinBZhangGuide
          ? JSON.stringify({
              user: tt,
              url: '',
              status: 2
            })
          : ''
        : val

      if (us.includes('【原文内容】')) {
        us = us.replace('【原文内容】', this.original)
      }
      const objMsgData = {
        user: us,
        user_msg: us,
        scene_id: tmp.type === 'AI' ? 1 : tmp.type,
        llm_type: this.getIsShowDouyinBZhangGuide ? 2 : this.getModelType(),
        qa_mode: tmp.type === 'AI' || !isTemplate ? mode || 'free' : 'compose',
        chat_template: isTemplate ? val : undefined,
        conversation_id: this.conversationId,
        task_id: params.task_id ?? '',
        format: params.format ?? '',
        file_url: params.file_url ?? '',
        file_name: params.file_name ?? '',
        file_size: params.file_size ?? '',
        searchEnable: this.isEarth ? 1 : 0
      }
      console.log(`output->4564654465`, objMsgData)
      // 添加师资的权限
      const item = this.getTypeAIList.find(item => item.checked)
      if (item?.llmTypes?.length && item?.llmTypes?.includes(12)) {
        objMsgData.ext = { authorization: getToken() }
        objMsgData.llm_type = item?.llmTypes[0]
        if (this.getRealConversationId()) {
          objMsgData.real_conversation_id = this.getRealConversationId()
        }
      }
      ws.send(JSON.stringify(objMsgData))

      this.$nextTick(() => {
        this.chatValue = ''
        // 同步清空全局 store，确保再次点击同一快捷按钮能触发 watcher
        this.$store && this.$store.dispatch('ai/setChatValue', '')
      })
    },
    onhandleOpenThirdWeb(type) {
      switch (type) {
        case 2:
          // 打开B站
          window.open('https://www.bilibili.com/', '_blank')
          break
        case 1:
          // 打开抖音
          window.open('https://www.douyin.com/', '_blank')
          break
        case 3:
          // 打开小红书
          window.open('https://www.xiaohongshu.com/', '_blank')
          break
        case 4:
          // 打开快手
          window.open('https://www.kuaishou.com/', '_blank')
          break
        case 5:
          // 打开微博
          window.open('https://weibo.com/', '_blank')
          break
        case 6:
          // 打开今日头条
          window.open('https://www.toutiao.com/', '_blank')
          break
      }
    },
    handleCustomSelectClick(event) {
      if (!this.getIsAIEnd()) return
      event.stopPropagation() // 阻止事件冒泡
      this.$refs.modelSelect.visible = !this.$refs.modelSelect.visible
    },
    handleVisibleChange(visible) {
      this.isDropdownVisible = visible
    }
  }
}
</script>
<style lang="scss" scoped>
.no-drag {
  -webkit-user-drag: none; /* Safari */
  -khtml-user-drag: none; /* Konqueror */
  -moz-user-drag: none; /* Firefox */
  -o-user-drag: none; /* Opera */
  user-drag: none;
}
.custom-zyq-prpper {
  z-index: 99999 !important;
}

::v-deep .el-textarea__inner {
  font-size: 16px;
  color: #000;
  padding: 15px 14px;
  &::-webkit-input-placeholder {
    /* Chrome/Safari/Opera */
    color: #808080;
    font-family: 'PingFang SC';
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
  }

  &::-moz-placeholder {
    /* Firefox */
    color: #808080;
    font-family: 'PingFang SC';
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
  }

  &:-ms-input-placeholder {
    /* IE/Edge */
    color: #808080;
    font-family: 'PingFang SC';
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
  }

  &::placeholder {
    /* Modern browsers */
    color: #808080;
    font-family: 'PingFang SC';
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
  }
}
::v-deep .el-textarea__inner {
  color: #333;
  background-color: transparent;
  &::-webkit-scrollbar {
    width: 3px;
    height: 3px;
    // display: none;
    background-color: transparent;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 6px;
    background: #d0d0d0;
    transition: all 0.4s ease;
  }

  &::-webkit-scrollbar-track {
    background: #fff;
  }
}
::v-deep .is-disabled .el-textarea__inner {
  background-color: transparent;
}
.chat-input-container {
  border-radius: 10px;
  border: 1px solid #e5e9e9;
  background: #f4f4f4;
  position: relative;
  z-index: 99999999999999999999999;
  .stop-out {
    position: absolute;
    width: 128px;
    height: 32px;
    box-shadow: 0px 3px 6px 0px rgba(21, 36, 67, 0.1);
    border-radius: 16px;
    // border: 1px solid #0c6fff;
    display: flex;
    align-items: center;
    justify-content: center;
    right: 6.5%;
    top: -42px;
    left: 50%;
    margin-left: -64px;
    user-select: none;
    // margin: 16px 22px;
    background-color: #ffffff;
    transition: all 0.3s;
    z-index: 100;
    &:hover {
      background: #1778ff;
      span {
        color: #ffffff;
      }
      .stop-icon {
        display: none;
      }
      .stop-icon-hover {
        display: block;
      }
    }
    .stop-icon {
      width: 24px;
      height: 24px;
      margin-right: 4px;
    }
    .stop-icon-hover {
      display: none;
      width: 24px;
      height: 24px;
      margin-right: 4px;
      animation: stopIcon 1s infinite;
    }
    span {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #313233;
    }
  }
  .stop-out-full {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    // margin-left: -64px;
    bottom: 145px;
    margin-left: 0;
    z-index: 101;
  }
  .stop-out-ImageGeneration {
    bottom: 182px !important;
  }
  .file-upload-show {
    padding: 16px 16px 0;
    display: flex;
    overflow-x: auto;

    .img-box {
      position: relative;
      width: 100px;
      height: 100px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 5px;

      .mask {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        background-color: rgba($color: #333333, $alpha: 0.5);
        z-index: 1000;
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: center;

        .loading {
          width: 16px;
          height: 16px;
          display: flex;
          animation: spin 1s linear infinite;
        }

        @keyframes spin {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }
      }
    }

    .file-card {
      position: relative;
      border-radius: 10px;
      padding: 6px 26px 6px 6px;
      // height: 54px;
      background: #fff;
      border: 1px solid #e5e9e9;
      display: flex;
      align-items: center;
      justify-content: space-between;
      overflow: hidden;
      gap: 10px;
      max-width: 260px;

      .del-icon {
        position: absolute;
        right: 5px;
        top: 5px;
        display: flex;
        width: 12px;
        height: 12px;
      }

      .file-icon {
        position: relative;
        min-width: 55px;
        height: 55px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #fff;
        border-radius: 4px;

        .mask {
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
          background-color: rgba($color: #333333, $alpha: 0.5);
          z-index: 1000;
          border-radius: 4px;
          display: flex;
          align-items: center;
          justify-content: center;

          .loading {
            width: 16px;
            height: 16px;
            display: flex;
            animation: spin 1s linear infinite;
          }

          @keyframes spin {
            0% {
              transform: rotate(0deg);
            }
            100% {
              transform: rotate(360deg);
            }
          }
        }

        .icon {
          display: flex;
          height: 41px;
          width: 41px;
        }
      }

      .file-info {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        gap: 5px;
        width: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;

        .file-title {
          width: 100%;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          font-size: 14px;
          font-weight: 500;
          color: #000000;
        }
        .file-status,
        .file-detail {
          color: #979797;
          font-size: 12px;
        }
      }
    }
    .upload-image {
      width: 100%;
      height: 100%;
      border-radius: 5px;
      object-fit: cover;
    }

    .del-icon {
      position: absolute;
      right: 5px;
      top: 5px;
      display: flex;
      width: 12px;
      height: 12px;
      z-index: 1100;
    }
  }

  .input-bottom {
    padding-top: 13px;
    padding-bottom: 13px;
    padding-right: 10px;
    display: flex;
    justify-content: space-between;
    min-width: 0;
    flex-shrink: 0;

    // 左侧内容区域
    > div:first-child {
      flex: 1;
      min-width: 0;
      margin-left: 16px;

      .model-operate {
        display: flex;
        align-items: center;
        flex-wrap: nowrap;
        min-width: 0;

        .model-tip {
          white-space: nowrap;
          flex-shrink: 0;
          margin-right: 6px;
          font-size: 12px;
          color: #808080;
        }

        .select-wrapper {
          // margin-right: v-bind('isFullScreen() ? "12px" : "8px"');
        }
      }
    }

    // 右侧操作区域
    > .flex.items-center {
      flex-shrink: 0;
      // margin-left: v-bind('isFullScreen() ? "16px" : "8px"');
      // gap: v-bind('isFullScreen() ? "12px" : "8px"') !important;
    }

    .custom-display {
      // padding: 0 v-bind('isFullScreen() ? "10px" : "8px"');
    }
  }
  .recommend-topic {
    position: absolute;
    bottom: 100px;
    background: #fff;
    width: 100%;
    border-bottom: 1px solid #eee;
    z-index: 2;
  }
}

// 输入时对【】内文字进行高亮的覆盖层
.highlight-wrapper {
  position: relative;
}
.highlight-preview {
  position: absolute;
  inset: 0;
  padding: 15px 14px; // 与 .el-textarea__inner 一致
  color: #333; // 普通文字颜色
  white-space: pre-wrap;
  word-break: break-word;
  pointer-events: none;
  z-index: 1; // 覆盖在输入层之上
}
.highlight-wrapper.use-highlight ::v-deep .el-textarea__inner {
  position: relative;
  background: transparent;
  color: transparent; // 隐藏真实文字，显示覆盖层
  caret-color: #000; // 光标仍可见
}
.highlight-wrapper.use-highlight ::v-deep .el-textarea {
  background: transparent !important; // 确保外层容器透明
}
::v-deep .bracket-highlight {
  color: #1778ff; // 高亮颜色（穿透作用于 v-html 注入内容）
}
::v-deep .el-textarea__inner {
  border: none;
}

::v-deep .el-textarea.is-disabled .el-textarea__inner {
  background-color: rgba(0, 0, 0, 0);
}

.custom-display {
  display: inline-flex;
  height: 32px;
  padding: 0 10px;
  justify-content: center;
  align-items: center;
  gap: 5px;
  border-radius: 15px;
  border: 1px solid #e5e9e9;
  background: #fff;
  cursor: pointer;
  transition: all 0.3s;
  box-sizing: border-box;
  span {
    font-size: 12px !important;
    margin-right: 0px !important;
    color: #000000;
  }

  &:hover {
    border: 1px solid #d9d9d9;
    background: #e0e5ed;
    span {
      color: #000000;
    }
  }
  &.selected {
    border: 1px solid #c7daff;
    background: #e0edff;
    span {
      color: #3a7fff;
    }
  }
}

.select-wrapper {
  position: relative;
  display: inline-block;

  .origin-select {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 32px;
    opacity: 0;
    z-index: -1;
    &::v-deep .el-input__inner {
      cursor: pointer;
    }
  }
}
.model-operate {
  display: flex;
  align-items: center;
  .model-tip {
    font-size: 12px;
    color: #808080;
    margin-right: 6px;
  }
}
// 下拉菜单样式
::v-deep .el-select-dropdown {
  border-radius: 8px;

  .el-select-dropdown__item {
    &.selected {
      background: #e0edff;
      color: inherit;
    }

    &:hover {
      background: #e0e5ed;
    }
  }
}

.chat-input-length {
  color: #808080;
  font-family: 'PingFang SC';
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 12px;
  margin-right: 0px !important;
}

.select-arrow {
  width: 14px;
  height: 14px;
  margin-left: 5px;
  font-size: 14px;
  color: #c0c4cc;
  transition: transform 0.3s;
  display: inline-flex;
  align-items: center;

  &.is-reverse {
    transform: rotate(180deg);
  }
}
</style>
